import Playground from 'components/Playground';
import Modal from "components/Modal";
import Button from "components/Button";
import * as React from 'react';
export default {
  Playground,
  Modal,
  Button,
  React
};